import BaseService from "../../../services/BaseService";

class ParagraphQuestionService extends BaseService {}

export default new ParagraphQuestionService('health_backend', 'training/paragraph/questions');